import type { StyleSystemProps } from '@withjoy/joykit';
import { TextV2, styled } from '@withjoy/joykit';

export const StyledExternalLinkLabel = styled(TextV2)`
  font-weight: bold;
  line-height: 1.5rem;
  letter-spacing: -0.01rem;
  margin-top: 1rem;
`;

export const safeLinkCancelButtonStyles: Omit<StyleSystemProps, 'size'> = {
  fontWeight: 600,
  fontSize: '1rem',
  color: 'mono14',
  marginRight: 'auto',
  width: '7rem',
};

export const safeLinkCloseButtonStyles: Omit<StyleSystemProps, 'size'> = {
  fontWeight: 600,
  fontSize: '1rem',
  backgroundColor: 'mono14',
  width: '7.75rem',
};
